import { render, staticRenderFns } from "./pc-input-text.vue?vue&type=template&id=557cf27f&scoped=true&"
import script from "./pc-input-text.vue?vue&type=script&lang=ts&"
export * from "./pc-input-text.vue?vue&type=script&lang=ts&"
import style0 from "./pc-input-text.vue?vue&type=style&index=0&id=557cf27f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557cf27f",
  null
  
)

export default component.exports